export const treasuryAssetsProtocolTypeDescMock = {
  "data": [
      {
          "organizationCount": 201,
          "totalValue": 907993993.14,
          "updatedAt": "2025-09-21T14:23:05.000Z",
          "protocolType": "Liquidity Pool",
          "protocolName": ""
      },
      {
          "organizationCount": 198,
          "totalValue": 273457334.18,
          "updatedAt": "2025-09-21T14:13:41.000Z",
          "protocolType": "Vesting",
          "protocolName": ""
      },
      {
          "organizationCount": 172,
          "totalValue": 3058852923.77,
          "updatedAt": "2025-09-21T14:35:08.000Z",
          "protocolType": "Staking",
          "protocolName": ""
      },
      {
          "organizationCount": 131,
          "totalValue": 340646688.86,
          "updatedAt": "2025-09-21T13:56:48.000Z",
          "protocolType": "Deposit",
          "protocolName": ""
      },
      {
          "organizationCount": 129,
          "totalValue": 649340437.07,
          "updatedAt": "2025-09-21T14:22:03.000Z",
          "protocolType": "Yield",
          "protocolName": ""
      },
      {
          "organizationCount": 122,
          "totalValue": 755824531.88,
          "updatedAt": "2025-09-21T14:23:19.000Z",
          "protocolType": "Lending",
          "protocolName": ""
      },
      {
          "organizationCount": 103,
          "totalValue": 1521256.14,
          "updatedAt": "2025-09-21T14:30:49.000Z",
          "protocolType": "Rewards",
          "protocolName": ""
      },
      {
          "organizationCount": 86,
          "totalValue": 914407145.27,
          "updatedAt": "2025-09-21T14:16:45.000Z",
          "protocolType": "Farming",
          "protocolName": ""
      },
      {
          "organizationCount": 86,
          "totalValue": 123046444.46,
          "updatedAt": "2025-09-21T14:13:41.000Z",
          "protocolType": "Locked",
          "protocolName": ""
      },
      {
          "organizationCount": 24,
          "totalValue": 313517.94,
          "updatedAt": "2025-09-21T08:07:14.000Z",
          "protocolType": "Airdrop",
          "protocolName": ""
      }
  ],
  "apiAccountMetaData": {
      "endpoint": "https://api.deepdao.io/v0.1/treasury/total_treasuries_assets",
      "origin": "DeepDAO",
      "date": "2025-09-26T09:05:55.332Z"
  }
};

export const treasuryAssetsProtocolTypeAscMock = {
  "data": [
      {
          "organizationCount": 1,
          "totalValue": 2414051.51,
          "updatedAt": "2025-08-10T06:44:37.000Z",
          "protocolType": "Leveraged Farming",
          "protocolName": ""
      },
      {
          "organizationCount": 1,
          "totalValue": 610.75,
          "updatedAt": "2023-11-19T06:18:31.000Z",
          "protocolType": "Nft Liquidty Pool",
          "protocolName": ""
      },
      {
          "organizationCount": 3,
          "totalValue": 28574.84,
          "updatedAt": "2024-10-20T03:14:32.000Z",
          "protocolType": "Nft Staked",
          "protocolName": ""
      },
      {
          "organizationCount": 13,
          "totalValue": 8065189.87,
          "updatedAt": "2025-09-28T13:18:44.000Z",
          "protocolType": "Investment",
          "protocolName": ""
      },
      {
          "organizationCount": 24,
          "totalValue": 304932.69,
          "updatedAt": "2025-09-28T12:53:31.000Z",
          "protocolType": "Airdrop",
          "protocolName": ""
      },
      {
          "organizationCount": 86,
          "totalValue": 901868957.06,
          "updatedAt": "2025-09-28T14:21:20.000Z",
          "protocolType": "Farming",
          "protocolName": ""
      },
      {
          "organizationCount": 86,
          "totalValue": 115278586.33,
          "updatedAt": "2025-09-28T13:55:17.000Z",
          "protocolType": "Locked",
          "protocolName": ""
      },
      {
          "organizationCount": 103,
          "totalValue": 1444712.18,
          "updatedAt": "2025-09-28T14:21:20.000Z",
          "protocolType": "Rewards",
          "protocolName": ""
      },
      {
          "organizationCount": 122,
          "totalValue": 741746363.53,
          "updatedAt": "2025-09-28T14:37:18.000Z",
          "protocolType": "Lending",
          "protocolName": ""
      },
      {
          "organizationCount": 130,
          "totalValue": 640800829.45,
          "updatedAt": "2025-09-28T14:37:18.000Z",
          "protocolType": "Yield",
          "protocolName": ""
      }
  ],
  "apiAccountMetaData": {
      "endpoint": "https://api.deepdao.io/v0.1/treasury/total_treasuries_assets",
      "origin": "DeepDAO",
      "date": "2025-10-03T10:04:27.758Z"
  }
};

export const treasuryAssetsProtocolTypeTotalValueDescMock = {
  "data": [
      {
          "organizationCount": 172,
          "totalValue": 2414792414.64,
          "updatedAt": "2025-09-28T14:46:27.000Z",
          "protocolType": "Staking",
          "protocolName": ""
      },
      {
          "organizationCount": 86,
          "totalValue": 901868957.06,
          "updatedAt": "2025-09-28T14:21:20.000Z",
          "protocolType": "Farming",
          "protocolName": ""
      },
      {
          "organizationCount": 202,
          "totalValue": 890717641.38,
          "updatedAt": "2025-09-28T14:27:07.000Z",
          "protocolType": "Liquidity Pool",
          "protocolName": ""
      },
      {
          "organizationCount": 122,
          "totalValue": 741746363.53,
          "updatedAt": "2025-09-28T14:37:18.000Z",
          "protocolType": "Lending",
          "protocolName": ""
      },
      {
          "organizationCount": 130,
          "totalValue": 640800829.45,
          "updatedAt": "2025-09-28T14:37:18.000Z",
          "protocolType": "Yield",
          "protocolName": ""
      },
      {
          "organizationCount": 131,
          "totalValue": 340054360.37,
          "updatedAt": "2025-09-28T13:50:46.000Z",
          "protocolType": "Deposit",
          "protocolName": ""
      },
      {
          "organizationCount": 198,
          "totalValue": 244431537.27,
          "updatedAt": "2025-09-28T13:55:17.000Z",
          "protocolType": "Vesting",
          "protocolName": ""
      },
      {
          "organizationCount": 86,
          "totalValue": 115278586.33,
          "updatedAt": "2025-09-28T13:55:17.000Z",
          "protocolType": "Locked",
          "protocolName": ""
      },
      {
          "organizationCount": 13,
          "totalValue": 8065189.87,
          "updatedAt": "2025-09-28T13:18:44.000Z",
          "protocolType": "Investment",
          "protocolName": ""
      },
      {
          "organizationCount": 1,
          "totalValue": 2414051.51,
          "updatedAt": "2025-08-10T06:44:37.000Z",
          "protocolType": "Leveraged Farming",
          "protocolName": ""
      }
  ],
  "apiAccountMetaData": {
      "endpoint": "https://api.deepdao.io/v0.1/treasury/total_treasuries_assets",
      "origin": "DeepDAO",
      "date": "2025-10-03T10:05:03.121Z"
  }
};

export const treasuryAssetsProtocolTypeTotalValueAscMock = {
  "data": [
      {
          "organizationCount": 1,
          "totalValue": 610.75,
          "updatedAt": "2023-11-19T06:18:31.000Z",
          "protocolType": "Nft Liquidty Pool",
          "protocolName": ""
      },
      {
          "organizationCount": 3,
          "totalValue": 28574.84,
          "updatedAt": "2024-10-20T03:14:32.000Z",
          "protocolType": "Nft Staked",
          "protocolName": ""
      },
      {
          "organizationCount": 24,
          "totalValue": 304932.69,
          "updatedAt": "2025-09-28T12:53:31.000Z",
          "protocolType": "Airdrop",
          "protocolName": ""
      },
      {
          "organizationCount": 103,
          "totalValue": 1444712.18,
          "updatedAt": "2025-09-28T14:21:20.000Z",
          "protocolType": "Rewards",
          "protocolName": ""
      },
      {
          "organizationCount": 1,
          "totalValue": 2414051.51,
          "updatedAt": "2025-08-10T06:44:37.000Z",
          "protocolType": "Leveraged Farming",
          "protocolName": ""
      },
      {
          "organizationCount": 13,
          "totalValue": 8065189.87,
          "updatedAt": "2025-09-28T13:18:44.000Z",
          "protocolType": "Investment",
          "protocolName": ""
      },
      {
          "organizationCount": 86,
          "totalValue": 115278586.33,
          "updatedAt": "2025-09-28T13:55:17.000Z",
          "protocolType": "Locked",
          "protocolName": ""
      },
      {
          "organizationCount": 198,
          "totalValue": 244431537.27,
          "updatedAt": "2025-09-28T13:55:17.000Z",
          "protocolType": "Vesting",
          "protocolName": ""
      },
      {
          "organizationCount": 131,
          "totalValue": 340054360.37,
          "updatedAt": "2025-09-28T13:50:46.000Z",
          "protocolType": "Deposit",
          "protocolName": ""
      },
      {
          "organizationCount": 130,
          "totalValue": 640800829.45,
          "updatedAt": "2025-09-28T14:37:18.000Z",
          "protocolType": "Yield",
          "protocolName": ""
      }
  ],
  "apiAccountMetaData": {
      "endpoint": "https://api.deepdao.io/v0.1/treasury/total_treasuries_assets",
      "origin": "DeepDAO",
      "date": "2025-10-03T10:05:46.273Z"
  }
};


export const treasuryAssetsProtocolTypeDetailProtocolNameDescMock = {
  "data": [
      {
          "organizationCount": 12,
          "totalValue": 214487981.72,
          "updatedAt": "2025-09-21T12:16:06.000Z",
          "protocolName": "Aave V3",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 6,
          "totalValue": 307048.99,
          "updatedAt": "2025-09-21T11:37:07.000Z",
          "protocolName": "Aave V2",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 5,
          "totalValue": 94561.81,
          "updatedAt": "2025-09-21T11:37:12.000Z",
          "protocolName": "Compound",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 4,
          "totalValue": 23602361.41,
          "updatedAt": "2024-11-10T10:18:59.000Z",
          "protocolName": "Synthetix",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 4,
          "totalValue": 2064605.72,
          "updatedAt": "2025-09-21T00:11:30.000Z",
          "protocolName": "Silo",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 3,
          "totalValue": 15828740.08,
          "updatedAt": "2025-06-08T12:51:18.000Z",
          "protocolName": "Synthetix V3",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 3,
          "totalValue": 1810932.06,
          "updatedAt": "2025-09-21T05:27:08.000Z",
          "protocolName": "Curve Stablecoin",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 3,
          "totalValue": 3159610.71,
          "updatedAt": "2025-09-20T19:37:37.000Z",
          "protocolName": "Compound V3",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 3,
          "totalValue": 6110768.09,
          "updatedAt": "2025-09-21T12:18:04.000Z",
          "protocolName": "StakeWise",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 2,
          "totalValue": 5980.24,
          "updatedAt": "2025-09-21T05:27:07.000Z",
          "protocolName": "CLever CVX",
          "protocolType": "Debt"
      }
  ],
  "apiAccountMetaData": {
      "endpoint": "https://api.deepdao.io/v0.1/treasury/total_treasuries_assets",
      "origin": "DeepDAO",
      "date": "2025-09-26T09:05:55.321Z"
  }
};

export const treasuryAssetsProtocolTypeDetailProtocolNameAscMock = {
  "data": [
      {
          "organizationCount": 1,
          "totalValue": 3235730.29,
          "updatedAt": "2025-08-10T09:42:53.000Z",
          "protocolName": "Euler",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 1,
          "totalValue": 49701047.97,
          "updatedAt": "2025-09-28T03:21:57.000Z",
          "protocolName": "Contango",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 1,
          "totalValue": 46318.74,
          "updatedAt": "2024-02-04T12:08:20.000Z",
          "protocolName": "Ethos Reserve",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 1,
          "totalValue": 776323.83,
          "updatedAt": "2024-12-22T13:47:22.000Z",
          "protocolName": "Curve LlamaLend",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 1,
          "totalValue": 10857.63,
          "updatedAt": "2025-09-28T03:22:52.000Z",
          "protocolName": "Bao.Finance",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 1,
          "totalValue": 2689624.24,
          "updatedAt": "2025-09-28T10:24:25.000Z",
          "protocolName": "Cap",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 1,
          "totalValue": 62107.57,
          "updatedAt": "2024-01-07T15:06:45.000Z",
          "protocolName": "Agave",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 1,
          "totalValue": 1364879.25,
          "updatedAt": "2025-07-20T11:30:06.000Z",
          "protocolName": "EBTC",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 1,
          "totalValue": 291640.06,
          "updatedAt": "2025-08-10T06:44:37.000Z",
          "protocolName": "Angle Protocol",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 1,
          "totalValue": 164.42,
          "updatedAt": "2025-09-28T09:51:53.000Z",
          "protocolName": "Fluid",
          "protocolType": "Debt"
      }
  ],
  "apiAccountMetaData": {
      "endpoint": "https://api.deepdao.io/v0.1/treasury/total_treasuries_assets",
      "origin": "DeepDAO",
      "date": "2025-10-02T12:05:19.455Z"
  }
}

export const treasuryAssetsProtocolTypeDetailProtocolNameTotalUsdDescMock = {
  "data": [
      {
          "organizationCount": 12,
          "totalValue": 205205566.76,
          "updatedAt": "2025-09-28T10:16:05.000Z",
          "protocolName": "Aave V3",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 1,
          "totalValue": 49701047.97,
          "updatedAt": "2025-09-28T03:21:57.000Z",
          "protocolName": "Contango",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 4,
          "totalValue": 23602361.41,
          "updatedAt": "2024-11-10T10:18:59.000Z",
          "protocolName": "Synthetix",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 3,
          "totalValue": 15828740.08,
          "updatedAt": "2025-06-08T12:51:18.000Z",
          "protocolName": "Synthetix V3",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 2,
          "totalValue": 13728588.16,
          "updatedAt": "2025-09-28T07:24:46.000Z",
          "protocolName": "Spark",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 2,
          "totalValue": 11232116.78,
          "updatedAt": "2024-08-18T04:53:55.000Z",
          "protocolName": "Maker",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 1,
          "totalValue": 10741309.84,
          "updatedAt": "2024-12-29T13:50:01.000Z",
          "protocolName": "UwU Lend",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 3,
          "totalValue": 5581823.94,
          "updatedAt": "2025-09-28T13:38:11.000Z",
          "protocolName": "StakeWise",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 2,
          "totalValue": 5311295.38,
          "updatedAt": "2025-09-28T13:08:16.000Z",
          "protocolName": "Morpho",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 1,
          "totalValue": 3235730.29,
          "updatedAt": "2025-08-10T09:42:53.000Z",
          "protocolName": "Euler",
          "protocolType": "Debt"
      }
  ],
  "apiAccountMetaData": {
      "endpoint": "https://api.deepdao.io/v0.1/treasury/total_treasuries_assets",
      "origin": "DeepDAO",
      "date": "2025-10-02T12:08:38.773Z"
  }
}

export const treasuryAssetsProtocolTypeDetailProtocolNameTotalUsdAscMock = {
  "data": [
      {
          "organizationCount": 1,
          "totalValue": 0,
          "updatedAt": "2025-09-28T09:43:32.000Z",
          "protocolName": "Lodestar V1",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 1,
          "totalValue": 0,
          "updatedAt": "2024-10-24T10:15:14.000Z",
          "protocolName": "Lybra Finance",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 1,
          "totalValue": 0,
          "updatedAt": "2025-09-28T01:24:10.000Z",
          "protocolName": "Threshold",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 1,
          "totalValue": 0.34,
          "updatedAt": "2024-10-12T15:31:29.000Z",
          "protocolName": "Radiant Capital V2",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 1,
          "totalValue": 0.48,
          "updatedAt": "2025-09-28T13:51:34.000Z",
          "protocolName": "Morpho Compound",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 2,
          "totalValue": 20.38,
          "updatedAt": "2025-09-28T03:35:07.000Z",
          "protocolName": "Aave V1",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 1,
          "totalValue": 35.22,
          "updatedAt": "2024-11-24T16:44:13.000Z",
          "protocolName": "ZeroLend",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 1,
          "totalValue": 60.63,
          "updatedAt": "2025-09-28T00:16:53.000Z",
          "protocolName": "Lista DAO",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 1,
          "totalValue": 116.15,
          "updatedAt": "2025-09-28T14:37:18.000Z",
          "protocolName": "Sturdy V2",
          "protocolType": "Debt"
      },
      {
          "organizationCount": 1,
          "totalValue": 164.42,
          "updatedAt": "2025-09-28T09:51:53.000Z",
          "protocolName": "Fluid",
          "protocolType": "Debt"
      }
  ],
  "apiAccountMetaData": {
      "endpoint": "https://api.deepdao.io/v0.1/treasury/total_treasuries_assets",
      "origin": "DeepDAO",
      "date": "2025-10-02T12:09:11.607Z"
  }
}

export const treasuryAssetsProtocolTypeProtocolNameOrgCountDescMock = {
  "data": [
      {
          "organizationCount": 180,
          "totalValue": 146809700.01,
          "updatedAt": "2025-09-28T13:55:17.000Z",
          "protocolName": "Gnosis Safe",
          "protocolType": "Vesting"
      },
      {
          "organizationCount": 85,
          "totalValue": 368992276.17,
          "updatedAt": "2025-09-28T14:38:42.000Z",
          "protocolName": "LIDO",
          "protocolType": "Staking"
      },
      {
          "organizationCount": 82,
          "totalValue": 367460949.11,
          "updatedAt": "2025-09-28T13:38:11.000Z",
          "protocolName": "Uniswap V3",
          "protocolType": "Liquidity Pool"
      },
      {
          "organizationCount": 48,
          "totalValue": 92094857.63,
          "updatedAt": "2025-09-28T13:38:12.000Z",
          "protocolName": "Balancer V2",
          "protocolType": "Liquidity Pool"
      },
      {
          "organizationCount": 45,
          "totalValue": 296285023.96,
          "updatedAt": "2025-09-28T14:20:54.000Z",
          "protocolName": "Aave V3",
          "protocolType": "Lending"
      },
      {
          "organizationCount": 45,
          "totalValue": 21900094.92,
          "updatedAt": "2025-09-28T13:31:03.000Z",
          "protocolName": "Curve",
          "protocolType": "Liquidity Pool"
      },
      {
          "organizationCount": 45,
          "totalValue": 200172325.06,
          "updatedAt": "2025-09-28T12:53:31.000Z",
          "protocolName": "Uniswap V2",
          "protocolType": "Liquidity Pool"
      },
      {
          "organizationCount": 41,
          "totalValue": 126346.46,
          "updatedAt": "2025-09-28T13:43:10.000Z",
          "protocolName": "Merkl",
          "protocolType": "Rewards"
      },
      {
          "organizationCount": 33,
          "totalValue": 12946535.65,
          "updatedAt": "2025-09-28T14:00:02.000Z",
          "protocolName": "SushiSwap",
          "protocolType": "Liquidity Pool"
      },
      {
          "organizationCount": 30,
          "totalValue": 46926814.11,
          "updatedAt": "2025-09-28T13:51:38.000Z",
          "protocolName": "Convex",
          "protocolType": "Staking"
      }
  ],
  "apiAccountMetaData": {
      "endpoint": "https://api.deepdao.io/v0.1/treasury/total_treasuries_assets",
      "origin": "DeepDAO",
      "date": "2025-10-02T11:10:13.953Z"
  }
};

export const treasuryAssetsProtocolTypeProtocolNameOrgCountAscMock = {
  "data": [
      {
          "organizationCount": 1,
          "totalValue": 3.53,
          "updatedAt": "2025-09-09T05:51:11.000Z",
          "protocolName": "Abracadabra",
          "protocolType": "Lending"
      },
      {
          "organizationCount": 1,
          "totalValue": 1.75,
          "updatedAt": "2025-09-28T00:06:51.000Z",
          "protocolName": "Abacus",
          "protocolType": "Rewards"
      },
      {
          "organizationCount": 1,
          "totalValue": 132641.61,
          "updatedAt": "2025-09-28T03:13:06.000Z",
          "protocolName": "Aave V3",
          "protocolType": "Yield"
      },
      {
          "organizationCount": 1,
          "totalValue": 663604.07,
          "updatedAt": "2025-09-28T09:47:05.000Z",
          "protocolName": "Abracadabra",
          "protocolType": "Yield"
      },
      {
          "organizationCount": 1,
          "totalValue": 0,
          "updatedAt": "2025-09-28T01:01:55.000Z",
          "protocolName": "88mph V2",
          "protocolType": "Vesting"
      },
      {
          "organizationCount": 1,
          "totalValue": 323.94,
          "updatedAt": "2025-09-28T10:07:50.000Z",
          "protocolName": "1inch",
          "protocolType": "Airdrop"
      },
      {
          "organizationCount": 1,
          "totalValue": 15516.8,
          "updatedAt": "2025-09-28T00:03:38.000Z",
          "protocolName": "Aave AMM",
          "protocolType": "Lending"
      },
      {
          "organizationCount": 1,
          "totalValue": 4915674.16,
          "updatedAt": "2025-09-28T07:36:53.000Z",
          "protocolName": "0x",
          "protocolType": "Staking"
      },
      {
          "organizationCount": 1,
          "totalValue": 99.98,
          "updatedAt": "2025-09-28T01:01:55.000Z",
          "protocolName": "88mph V2",
          "protocolType": "Locked"
      },
      {
          "organizationCount": 1,
          "totalValue": 14207739.33,
          "updatedAt": "2025-09-28T10:47:45.000Z",
          "protocolName": "Abracadabra",
          "protocolType": "Liquidity Pool"
      }
  ],
  "apiAccountMetaData": {
      "endpoint": "https://api.deepdao.io/v0.1/treasury/total_treasuries_assets",
      "origin": "DeepDAO",
      "date": "2025-10-02T11:26:01.710Z"
  }
}

export const treasuryAssetsProtocolTypeProtocolNameTotalValueDescMock = {
  "data": [
      {
          "organizationCount": 2,
          "totalValue": 1158756477.55,
          "updatedAt": "2025-09-28T14:46:27.000Z",
          "protocolName": "Eth2",
          "protocolType": "Staking"
      },
      {
          "organizationCount": 2,
          "totalValue": 545961914.52,
          "updatedAt": "2025-09-28T10:59:43.000Z",
          "protocolName": "Sky",
          "protocolType": "Farming"
      },
      {
          "organizationCount": 2,
          "totalValue": 420245669.12,
          "updatedAt": "2025-09-28T10:59:44.000Z",
          "protocolName": "Maker Governance",
          "protocolType": "Staking"
      },
      {
          "organizationCount": 85,
          "totalValue": 368992276.17,
          "updatedAt": "2025-09-28T14:38:42.000Z",
          "protocolName": "LIDO",
          "protocolType": "Staking"
      },
      {
          "organizationCount": 82,
          "totalValue": 367460949.11,
          "updatedAt": "2025-09-28T13:38:11.000Z",
          "protocolName": "Uniswap V3",
          "protocolType": "Liquidity Pool"
      },
      {
          "organizationCount": 45,
          "totalValue": 296285023.96,
          "updatedAt": "2025-09-28T14:20:54.000Z",
          "protocolName": "Aave V3",
          "protocolType": "Lending"
      },
      {
          "organizationCount": 5,
          "totalValue": 202540188.92,
          "updatedAt": "2025-04-27T03:17:08.000Z",
          "protocolName": "EigenLayer",
          "protocolType": "Deposit"
      },
      {
          "organizationCount": 45,
          "totalValue": 200172325.06,
          "updatedAt": "2025-09-28T12:53:31.000Z",
          "protocolName": "Uniswap V2",
          "protocolType": "Liquidity Pool"
      },
      {
          "organizationCount": 25,
          "totalValue": 192798877.02,
          "updatedAt": "2025-09-28T13:38:11.000Z",
          "protocolName": "Aura Finance",
          "protocolType": "Farming"
      },
      {
          "organizationCount": 6,
          "totalValue": 166691442.21,
          "updatedAt": "2025-09-28T10:25:13.000Z",
          "protocolName": "EigenLayer",
          "protocolType": "Yield"
      }
  ],
  "apiAccountMetaData": {
      "endpoint": "https://api.deepdao.io/v0.1/treasury/total_treasuries_assets",
      "origin": "DeepDAO",
      "date": "2025-10-02T11:48:11.904Z"
  }
}

export const treasuryAssetsProtocolTypeProtocolNameTotalValueAscMock = {
  "data": [
      {
          "organizationCount": 1,
          "totalValue": 0,
          "updatedAt": "2025-09-28T02:52:59.000Z",
          "protocolName": "Blur",
          "protocolType": "Staking"
      },
      {
          "organizationCount": 1,
          "totalValue": 0,
          "updatedAt": "2024-05-04T22:03:58.000Z",
          "protocolName": "AutoFarm",
          "protocolType": "Farming"
      },
      {
          "organizationCount": 1,
          "totalValue": 0,
          "updatedAt": "2025-05-23T13:11:39.000Z",
          "protocolName": "Blueprint",
          "protocolType": "Locked"
      },
      {
          "organizationCount": 1,
          "totalValue": 0,
          "updatedAt": "2025-09-28T00:06:51.000Z",
          "protocolName": "Beets",
          "protocolType": "Liquidity Pool"
      },
      {
          "organizationCount": 1,
          "totalValue": 0,
          "updatedAt": "2025-09-28T01:01:55.000Z",
          "protocolName": "88mph V2",
          "protocolType": "Vesting"
      },
      {
          "organizationCount": 1,
          "totalValue": 0,
          "updatedAt": "2025-09-11T09:23:04.000Z",
          "protocolName": "Ape Bond",
          "protocolType": "Yield"
      },
      {
          "organizationCount": 1,
          "totalValue": 0,
          "updatedAt": "2025-02-12T20:09:18.000Z",
          "protocolName": "Bao.Finance",
          "protocolType": "Liquidity Pool"
      },
      {
          "organizationCount": 1,
          "totalValue": 0,
          "updatedAt": "2025-08-20T06:21:58.000Z",
          "protocolName": "Archly V2",
          "protocolType": "Locked"
      },
      {
          "organizationCount": 1,
          "totalValue": 0,
          "updatedAt": "2025-09-03T10:07:22.000Z",
          "protocolName": "Alchemix V2",
          "protocolType": "Lending"
      },
      {
          "organizationCount": 1,
          "totalValue": 0,
          "updatedAt": "2025-09-06T06:02:41.000Z",
          "protocolName": "ComethSwap",
          "protocolType": "Liquidity Pool"
      }
  ],
  "apiAccountMetaData": {
      "endpoint": "https://api.deepdao.io/v0.1/treasury/total_treasuries_assets",
      "origin": "DeepDAO",
      "date": "2025-10-02T11:48:10.783Z"
  }
};


export const topAumOrganizationsMock = {
  "data": [
      {
          "id": "30d12da9-5fd5-411a-8ca8-1422a4ce1373",
          "title": "Mantle (formerly: BitDAO)",
          "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/30d12da9-5fd5-411a-8ca8-1422a4ce1373.webp"
      },
      {
          "id": "fe6aa70f-4877-4f6d-9c18-9a8cafc1fe28",
          "title": "Uniswap",
          "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/fe6aa70f-4877-4f6d-9c18-9a8cafc1fe28.webp"
      },
      {
          "id": "228c8be1-9d1e-440c-8afb-a40d6ee480f2",
          "title": "ENS DAO",
          "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/228c8be1-9d1e-440c-8afb-a40d6ee480f2.webp"
      },
      {
          "id": "b29f3be3-d4c7-4401-92cd-73390f09816b",
          "title": "Arbitrum",
          "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/b29f3be3-d4c7-4401-92cd-73390f09816b.webp"
      },
      {
          "id": "10edb97a-9dba-448a-88b1-ca263a7c75ad",
          "title": "Optimism",
          "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/10edb97a-9dba-448a-88b1-ca263a7c75ad.webp"
      },
      {
          "id": "529571a8-5816-47ff-a50e-1e6372e2324b",
          "title": "GnosisDAO",
          "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/529571a8-5816-47ff-a50e-1e6372e2324b.webp"
      },
      {
          "id": "c0dd1775-1e51-41a0-ae93-bfefb4835358",
          "title": "Ethereum Foundation",
          "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/c0dd1775-1e51-41a0-ae93-bfefb4835358.webp"
      },
      {
          "id": "d7eab985-c59e-4c44-9d87-00a2b87c900a",
          "title": "DeXe Protocol DAO",
          "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/d7eab985-c59e-4c44-9d87-00a2b87c900a.webp"
      },
      {
          "id": "c41f87df-35a6-4a37-82c4-62cd5a3a8c08",
          "title": "Sky (fka: MakerDAO)",
          "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/c41f87df-35a6-4a37-82c4-62cd5a3a8c08.webp"
      },
      {
          "id": "34e49a9f-34e2-477b-9c4f-914f8bc48aa7",
          "title": "ResearchHub Foundation",
          "logo": "https://deepdao-uploads.s3.us-east-2.amazonaws.com/organization/34e49a9f-34e2-477b-9c4f-914f8bc48aa7.webp"
      }
  ]
};